const CODE_MAP: Record<string, string> = {
  invalid_credentials: "Невірний email або пароль",
  email_not_confirmed: "Email не підтверджено. Перевірте пошту",
  user_already_exists: "Користувач з таким email вже зареєстрований",
  user_not_found: "Користувача не знайдено",
  weak_password: "Пароль занадто короткий або слабкий",
  same_password: "Новий пароль збігається з поточним",
  otp_expired: "Посилання недійсне або застаріле",
  over_request_rate_limit: "Занадто багато спроб. Спробуйте пізніше",
  over_email_send_rate_limit: "Занадто багато листів. Спробуйте пізніше",
  validation_failed: "Перевірте введені дані",
  session_expired: "Сесію завершено. Увійдіть знову",
  refresh_token_not_found: "Сесію завершено. Увійдіть знову",
  bad_jwt: "Немає доступу. Увійдіть в акаунт",
  insufficient_privileges: "Немає доступу до цієї дії",
  row_level_security_violation: "Немає доступу до цієї дії",
  unique_violation: "Такий запис вже існує",
  check_violation: "Перевірте введені дані",
  not_null_violation: "Заповніть усі обовʼязкові поля",
  foreign_key_violation: "Повʼязаний запис не знайдено",
  "23505": "Такий запис вже існує",
  "42501": "Немає доступу до цієї дії",
  "23503": "Повʼязаний запис не знайдено",
  "23502": "Заповніть усі обовʼязкові поля",
  "23514": "Перевірте введені дані",
};

export const translateError = (
  error: { code?: string; message?: string } | null | undefined
): string => {
  if (!error) return "Сталася помилка. Спробуйте ще раз";
  const ua = error.code ? CODE_MAP[error.code] : undefined;
  return ua ?? error.message ?? "Сталася помилка. Спробуйте ще раз";
};

export const throwUa = (
  error: { code?: string; message?: string } | null | undefined
): never => {
  throw new Error(translateError(error));
};
